<template>
<div class="styled-radio styled-radio--ou-donation row">
  <div v-for="amount of amounts" :key="amount" class="radio-part" :data-amount="amount">
      <input :id="`amount${amount}`" type="radio" class="amount" @click="selectedAmount = amount" :checked="selectedAmount == amount">
      <FormLabel :for="`amount${amount}`" :data-amount="amount">
		  <span class="label-amount">{{ form.currency === 'ILS' ? '₪' : '$' }}{{ amount }}</span>
	  </FormLabel>
  </div>

  <div class="amount_other__wrapper" v-if="includeOther" :class="[form.currency, { 'lang-he': lang === 'he' }]">
      <input id="amount_other_check" type="radio" class="amount" name="amount" value="Other">
      <input id="amount_other_field" type="number" min="1" name="amount_other" :placeholder="lang === 'he' ? 'סכום אחר' : amountText" v-model="customAmount" />
  </div>
</div>
</template>
<script setup lang="ts">
import { computed, ref, watch } from 'vue'
import { usePaymentForm } from '~/shared/use-payment-form'
import { queryParams } from '~/shared/query-params'

const props = withDefaults(defineProps<{
  subunits?: boolean
  includeOther?: boolean
  defaultCheckedAount?: string
  amountText?: string
  lang?: string
}>(), {
  subunits: true,
  includeOther: true,
  amountText: "Amount",
  lang: 'en'
})

const paymentForm = usePaymentForm()
if (!paymentForm) {
  throw new Error('PaymentForm context not available')
}
const { setValue, form, settings } = paymentForm

const selectedAmount = ref()
const customAmount = ref(form.value.amount)

watch(selectedAmount, (selectedAmount) => {
  if (selectedAmount) {
    customAmount.value = null

    setValue('amount', '' + selectedAmount)
  }
})

watch(customAmount, (customAmount) => {
  if (customAmount) selectedAmount.value = null

  if (!selectedAmount.value) setValue('amount', customAmount || null)
})

const amounts = computed(() => {
  // settings is a plain object, not a Ref
  if (!settings || !settings.amounts) {
    return []
  }

  const amountsConfig = settings.amounts

  if (Array.isArray(amountsConfig)) {
    return amountsConfig
  }

  // Handle currency-specific amounts
  const currency = form.value.currency || 'USD'
  return amountsConfig[currency] || []
})

const params = queryParams()

if (params.amount) {
  //@ts-ignore
  if (amounts.value.includes(+params.amount)) {
    selectedAmount.value = params.amount
  }
  else {
    customAmount.value = params.amount
  }
}


if (props.defaultCheckedAount) {
  //@ts-ignore
  if (amounts.value.includes(+props.defaultCheckedAount)) {
    selectedAmount.value = props.defaultCheckedAount
  }
  else {
    customAmount.value = props.defaultCheckedAount
  }
}
</script>
<style scoped lang="scss">
.oudonate-other-amount .amount_other__wrapper,
.styled-radio--ou-donation  .amount_other__wrapper{
    position: relative;
    margin-bottom: 10px;
    margin-right: 0;
    min-width: 16.6%;
    max-width: 31.6%;
    overflow: hidden;
    border: 1px solid #ddd;
    border-radius: 4px;
    padding-left: 5px;
    flex: 1;
    line-height: 1;
    @media (max-width: 720px) {
      margin-right: 5px;
      margin-left: 5px;
      margin-bottom: 10px;
    }
    &:before {
      content: '$';
      position: absolute;
      padding: 15px 8px;
      border-right: 1px solid #ddd;
      height: 100%;
      background: #fff;
      top: 0px;
      left: 0;
    }
    &.USD:before {content: '$'}
    &.CAN:before {content: 'C$'}
    &.ILS:before {content: '₪'}

    input[type='number'] {
      border: none;
      margin-left: 20px;
      box-shadow: none;
      width: calc(100% + 20px);
      font-size: 12px;
    }
    &.lang-he {
      padding-left: 0;
      padding-right: 5px;
      margin-right: 5px;
      direction: rtl;

      &:before {
        left: auto;
        right: 0;
        border-right: none;
        border-left: 1px solid #ddd;
      }

      input[type='number'] {
        margin-left: 0;
        margin-right: 20px;
      }
    }
    &:after {
      display: none !important;
    }
  }
.styled-radio--ou-donation.styled-radio {
  margin: 0 0 5px 0px;
  display: flex;
  flex-wrap: wrap;
  width: 100%;

  .radio-part {
    padding: 0px 5px;
    line-height: 1;
    @media (max-width: 720px) {
      width: 50%;
      margin-bottom: 10px;
    }
    @media (min-width: 720px) {
      min-width: 16.6666%;
      flex: 1;
      padding-right: 10px;
      padding-left: 0;
      max-width: 16.6666%;
      margin-bottom: 10px;

      &:nth-child(6n) {
        padding-right: 0;
      }
    }
  }
  input[type='radio'] {
    height: 0;
    top: 20px;
    position: relative;
    left: 20px;
    z-index: -1;
    visibility: hidden;
  }
  label {
    padding: 15px;
    background: #fff;
    border: 1px solid #ddd;
    font-weight: bold;
    color: rgb(87, 87, 87);
    width: 100%;
    text-align: center;
    border-radius: 4px;
    cursor: pointer;
    margin-top: -15px;
    display: block;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  input[type='radio']:checked + label {
    background: $color-blue;
    color: white;
  }
  label:hover {
    background: #e9f0f7;
  }
  .amount_other__wrapper {
    input[type='number'] {
      background: #fff;
      margin-top: -15px;
    }
  }
}
</style>
